"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfDrawingObjectRunPropertiesHelper = void 0;
var rtf_drawing_keywords_1 = require("../../../../translation-table/rtf-drawing-keywords");
var RtfDrawingObjectRunPropertiesHelper = (function () {
    function RtfDrawingObjectRunPropertiesHelper(shapeProperties) {
        this.shapeProperties = shapeProperties;
    }
    RtfDrawingObjectRunPropertiesHelper.prototype.applyProperties = function (anchorInfo) {
        this.applyTextWrap(anchorInfo);
    };
    RtfDrawingObjectRunPropertiesHelper.prototype.applyTextWrap = function (anchorInfo) {
        this.shapeProperties.trySetProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.ShapeWrapTextType, function (value) { return anchorInfo.wrapType = value; });
        this.shapeProperties.trySetProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.ShapeWrapTextSide, function (value) { return anchorInfo.wrapSide = value; });
    };
    return RtfDrawingObjectRunPropertiesHelper;
}());
exports.RtfDrawingObjectRunPropertiesHelper = RtfDrawingObjectRunPropertiesHelper;
